import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _catalogProductData = { productData: '_productData' };
var _domainData = { wixDomainData: '_wixDomainData' };
var _freeTrialData = { endDate: 'google.protobuf.Timestamp' };
var _getSitesPremiumStatusRequest = {};
var _getSitesPremiumStatusResponse = {};
var _listSitePremiumAssetsOfflineBulkRequest = {
    filter: '_premiumAssetFilter',
};
var _listSitePremiumAssetsOfflineResponse = { assets: '_premiumAsset' };
var _listUserPermittedPremiumAssetsRequest = {
    filter: '_premiumAssetFilter',
};
var _listUserPermittedPremiumAssetsResponse = { assets: '_premiumAsset' };
var _listUserPremiumAssetsRequest = { filter: '_premiumAssetFilter' };
var _listUserPremiumAssetsResponse = { assets: '_premiumAsset' };
var _manualRenewalWindowWithCurrentPaymentMethod = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _nextPaymentDetails = { date: 'google.protobuf.Timestamp' };
var _nextRenewalDateFilter = {
    fromDate: 'google.protobuf.Timestamp',
    toDate: 'google.protobuf.Timestamp',
};
var _pastPaymentDetails = { date: 'google.protobuf.Timestamp' };
var _planData = { trialEndDate: 'google.protobuf.Timestamp' };
var _premiumAsset = {
    assetCreationDate: 'google.protobuf.Timestamp',
    wixBillingDetails: '_wixBillingDetails',
    plansSpecificData: '_planData',
    domainsSpecificData: '_domainData',
    catalogProductData: '_catalogProductData',
    freeTrialData: '_freeTrialData',
};
var _premiumAssetFilter = { nextRenewalDate: '_nextRenewalDateFilter' };
var _productData = { trialEndDate: 'google.protobuf.Timestamp' };
var _recollectAssetsRequest = {};
var _recollectAssetsResponse = {};
var _recollectUserRequest = {};
var _recollectUserResponse = {};
var _timeInterval = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
};
var _wixBillingDetails = {
    subscriptionEndDate: 'google.protobuf.Timestamp',
    lastPaymentDetails: '_pastPaymentDetails',
    nextPaymentDetails: '_nextPaymentDetails',
    lastSuccessfulPaymentDetails: '_pastPaymentDetails',
    manualRenewalWindow: '_manualRenewalWindowWithCurrentPaymentMethod',
};
var _wixDomainData = {
    registrarExpirationDate: 'google.protobuf.Timestamp',
    validExtendPeriod: '_timeInterval',
    redemptionPeriod: '_timeInterval',
};
function resolveComWixpressPremiumDataviewAssetsV1UserPremiumAssetsServiceV1Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-data-view-retriever-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressPremiumDataviewAssetsV1SitePremiumAssetsServiceV1Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/premium-data-view-retriever-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'premium._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/premium-assets',
                destPath: '/api',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * etrieve premium assets for list of sites  using filters and paging (limited 50 sites per request) required permission PREMIUM.SITE_PREMIUM_ASSETS_SERVICE.LIST_SITE_PREMIUM_ASSETS_OFFLINE_BULK with specific metaSiteId in context
 * @deprecated It has been replaced with com.wixpress.premium.asset.reader.v2.PremiumAssetReaderService.QueryPremiumAssets().
 */
export function listSitePremiumAssetsOfflineBulkRest(payload) {
    var _a = serializer(_listSitePremiumAssetsOfflineBulkRequest, { _nextRenewalDateFilter: _nextRenewalDateFilter, _premiumAssetFilter: _premiumAssetFilter }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSitePremiumAssetsOfflineResponse, {
        _catalogProductData: _catalogProductData,
        _domainData: _domainData,
        _freeTrialData: _freeTrialData,
        _manualRenewalWindowWithCurrentPaymentMethod: _manualRenewalWindowWithCurrentPaymentMethod,
        _nextPaymentDetails: _nextPaymentDetails,
        _pastPaymentDetails: _pastPaymentDetails,
        _planData: _planData,
        _premiumAsset: _premiumAsset,
        _productData: _productData,
        _timeInterval: _timeInterval,
        _wixBillingDetails: _wixBillingDetails,
        _wixDomainData: _wixDomainData,
    }).fromJSON;
    function __listSitePremiumAssetsOfflineBulkRest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.SitePremiumAssetsServiceV1.ListSitePremiumAssetsOfflineBulkRest',
            url: resolveComWixpressPremiumDataviewAssetsV1SitePremiumAssetsServiceV1Url({ protoPath: '/api/v1/site/assets', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSitePremiumAssetsOfflineBulkRest.fromReq = fromReq;
    __listSitePremiumAssetsOfflineBulkRest.__isAmbassador = true;
    return __listSitePremiumAssetsOfflineBulkRest;
}
/** @deprecated It has been replaced with com.wixpress.premium.asset.reader.v2.PremiumAssetReaderService.ListSitesPremiumStatus(). */
export function getSitesPremiumStatus(payload) {
    var _a = serializer(_getSitesPremiumStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSitesPremiumStatusResponse, {}).fromJSON;
    function __getSitesPremiumStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.SitePremiumAssetsServiceV1.GetSitesPremiumStatus',
            url: resolveComWixpressPremiumDataviewAssetsV1SitePremiumAssetsServiceV1Url({ protoPath: '/api/v1/site/premium-status', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSitesPremiumStatus.fromReq = fromReq;
    __getSitesPremiumStatus.__isAmbassador = true;
    return __getSitesPremiumStatus;
}
/**
 * Retrieve premium assets owned by the target account in context
 * Supports filters and paging
 * @deprecated It has been replaced with com.wixpress.premium.asset.reader.v2.PremiumAssetReaderService.QueryPremiumAssets().
 */
export function listUserPremiumAssets(payload) {
    var _a = serializer(_listUserPremiumAssetsRequest, { _nextRenewalDateFilter: _nextRenewalDateFilter, _premiumAssetFilter: _premiumAssetFilter }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUserPremiumAssetsResponse, {
        _catalogProductData: _catalogProductData,
        _domainData: _domainData,
        _freeTrialData: _freeTrialData,
        _manualRenewalWindowWithCurrentPaymentMethod: _manualRenewalWindowWithCurrentPaymentMethod,
        _nextPaymentDetails: _nextPaymentDetails,
        _pastPaymentDetails: _pastPaymentDetails,
        _planData: _planData,
        _premiumAsset: _premiumAsset,
        _productData: _productData,
        _timeInterval: _timeInterval,
        _wixBillingDetails: _wixBillingDetails,
        _wixDomainData: _wixDomainData,
    }).fromJSON;
    function __listUserPremiumAssets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.UserPremiumAssetsServiceV1.ListUserPremiumAssets',
            url: resolveComWixpressPremiumDataviewAssetsV1UserPremiumAssetsServiceV1Url({ protoPath: '/api/v1/assets', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUserPremiumAssets.fromReq = fromReq;
    __listUserPremiumAssets.__isAmbassador = true;
    return __listUserPremiumAssets;
}
/**
 * retrieve all assets owned by the user and all assets for which he is contributor on with BILLING_MANAGER permissions or above
 * @deprecated It has been replaced with com.wixpress.premium.asset.reader.v2.PremiumAssetReaderService.QueryPremiumAssets().
 */
export function listUserPermittedPremiumAssets(payload) {
    var _a = serializer(_listUserPermittedPremiumAssetsRequest, { _nextRenewalDateFilter: _nextRenewalDateFilter, _premiumAssetFilter: _premiumAssetFilter }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listUserPermittedPremiumAssetsResponse, {
        _catalogProductData: _catalogProductData,
        _domainData: _domainData,
        _freeTrialData: _freeTrialData,
        _manualRenewalWindowWithCurrentPaymentMethod: _manualRenewalWindowWithCurrentPaymentMethod,
        _nextPaymentDetails: _nextPaymentDetails,
        _pastPaymentDetails: _pastPaymentDetails,
        _planData: _planData,
        _premiumAsset: _premiumAsset,
        _productData: _productData,
        _timeInterval: _timeInterval,
        _wixBillingDetails: _wixBillingDetails,
        _wixDomainData: _wixDomainData,
    }).fromJSON;
    function __listUserPermittedPremiumAssets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'GET',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.UserPremiumAssetsServiceV1.ListUserPermittedPremiumAssets',
            url: resolveComWixpressPremiumDataviewAssetsV1UserPremiumAssetsServiceV1Url({ protoPath: '/api/v1/premitted-assets', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listUserPermittedPremiumAssets.fromReq = fromReq;
    __listUserPermittedPremiumAssets.__isAmbassador = true;
    return __listUserPermittedPremiumAssets;
}
/**
 * Recollect data for the calling user
 * @deprecated
 */
export function recollectUser(payload) {
    var _a = serializer(_recollectUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_recollectUserResponse, {}).fromJSON;
    function __recollectUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.UserPremiumAssetsServiceV1.RecollectUser',
            url: resolveComWixpressPremiumDataviewAssetsV1UserPremiumAssetsServiceV1Url({ protoPath: '/api/v1/assets/recollect', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __recollectUser.fromReq = fromReq;
    __recollectUser.__isAmbassador = true;
    return __recollectUser;
}
/**
 * Recollect the assets specified by the premium IDs in the request
 * @deprecated
 */
export function recollectAssets(payload) {
    var _a = serializer(_recollectAssetsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_recollectAssetsResponse, {}).fromJSON;
    function __recollectAssets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.premium.v1.asset',
            method: 'POST',
            methodFqn: 'com.wixpress.premium.dataview.assets.v1.UserPremiumAssetsServiceV1.RecollectAssets',
            url: resolveComWixpressPremiumDataviewAssetsV1UserPremiumAssetsServiceV1Url({
                protoPath: '/api/v1/assets/recollect-assets',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __recollectAssets.fromReq = fromReq;
    __recollectAssets.__isAmbassador = true;
    return __recollectAssets;
}
//# sourceMappingURL=http.impl.js.map